export default __webpack_public_path__ + "media/images/socials-x-91979fa57d59d3ecadb4a7e24b5b7b9d.svg";